import { IState } from './useNewRoleContext';

export type ActionTypes =
  | 'UPDATE_CURRENT_STEP'
  | 'UPDATE_ROLE_NAME'
  | 'UPDATE_ROLE_DESCRIPTION'
  | 'UPDATE_ALL_ROLE_PERMISSIONS'
  | 'UPDATE_ROLE_PERMISSIONS'
  | 'UPDATE_VALID_STEPS'
  | 'UPDATE_USERS';

export interface IAction {
  type: ActionTypes;
  payload?: any;
}

export function newRoleReducer(state: IState, action: IAction): IState {
  switch (action.type) {
    case 'UPDATE_ROLE_NAME':
      return {
        ...state,
        name: action.payload.name,
      };
    case 'UPDATE_ROLE_DESCRIPTION':
      return {
        ...state,
        description: action.payload.description,
      };
    case 'UPDATE_ROLE_PERMISSIONS':
      return {
        ...state,
        permissions: action.payload.permissions,
      };
    case 'UPDATE_ALL_ROLE_PERMISSIONS':
      return {
        ...state,
        permissions: {
          Debug: action.payload.isSelected,
          ManageAssets: action.payload.isSelected,
          ManageCampaigns: action.payload.isSelected,
          ManageClients: action.payload.isSelected,
          ManageDispatchers: action.payload.isSelected,
          ManageEnrichments: action.payload.isSelected,
          ManageThirdPartyConsent: action.payload.isSelected,
          ManageFiles: action.payload.isSelected,
          ManageLinks: action.payload.isSelected,
          ManageSftpUsers: action.payload.isSelected,
          ManageTemplates: action.payload.isSelected,
          ManageTrends: action.payload.isSelected,
          ManageUnsubscribes: action.payload.isSelected,
          ManageUsers: action.payload.isSelected,
          ManageVoucherCodes: action.payload.isSelected,
          ViewAll: action.payload.isSelected,
          ViewDashboards: action.payload.isSelected,
        },
      };
    case 'UPDATE_USERS':
      return {
        ...state,
        users: action.payload?.users ?? [],
      };
    case 'UPDATE_VALID_STEPS':
      return {
        ...state,
        validSteps: action.payload?.validSteps ?? [],
      };
    case 'UPDATE_CURRENT_STEP':
      return {
        ...state,
        currentStep: action.payload.newStep,
      };
    default:
      return state;
  }
}
